import { render, staticRenderFns } from "./UserVisibilityForm.vue?vue&type=template&id=8070958e&"
import script from "./UserVisibilityForm.vue?vue&type=script&lang=ts&"
export * from "./UserVisibilityForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserVisibilityForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports